import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css']
})
export class SubscriptionsComponent implements OnInit {
    public selectedBgSubscriptionsMain: string = 'SUMPRSUB';

    public setting?: Setting;

    public itemsListSubscriptions: Item[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(848))[0];
    }

    private async loadSubscriptions() {
        this.itemsListSubscriptions = await this.datatask.Post(109);
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_subscriptions_grid').setLoadDataFunction({ method: 3468, parameters: {} }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadSetting();
        this.loadSubscriptions();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    filtervalue: string;
}
